const getters = {
  roles: state => state.user.roles,
  infos: state => state.user.infos,
}
export default getters